import React from "react";

const PISCONFINS = () => {
  return (
    <div style={{ padding: "2rem" }}>
      <h1>Rota /pisconfins funcionando ✅</h1>
    </div>
  );
};

export default PISCONFINS;